export function AllTrim(str) {
    return str.replace(/\s*/g, '');
  }

export function  CreditCard_ok (str1,str2){
    if(AllTrim(str1)===str2){
        return true;
    } else {
        return false;
    }
}
// export function  isChinese  () {
//     var reg = /[^\x00-\xff]/ig;//判断是否存在中文和全角字符
//     //    var reg=/[A-Za-z]*[a-z0-9_-]|\s$/;//判断是否包含数字字母下划线  当使用这个时如果只有部分是中文字符还可以使用英文字体
//     if (reg.test(this)) {
//         return true;//存在中文
//     }
//     return false;//不存在中文
// }
// 模拟资料
export function vInfo() {
    return {
        yourName:"Kumar Deep",
        MobileNumber:"+91996823010",
        email:"KumarDeep_185@hotmail.com",
        twoSVPhoneNum:"+91981059899",
        CompanyName:"JHAKAAS RETAIL PRIVATE LIMITED",
        address1:"CTS No. 658-A, 658-B, OFFICE NO 6, Gayatri Bhuvan",
        address2:"Complex 90 feetroad, Kandivali",
        pinCode:"400101",
        city:"Mumbai",
        state:"Maharashtra",
        GSTIN:"27AAECJ0000N1Z8",
        PAN:"AAECJ0000N",
        HolderName:"Jhakaas Retail Private Limited",
        AccountNum:"FPAYAMZ1111",
        IFSC:"CITI0101111"
		};
  }
//   需要帮助和知识点
  export function virtualConfigEntityList() {
    return [
      {currentPage:'in_p1',knowledgeBtn:'1',helpBtn:'1'},
      {currentPage:'in_p2',knowledgeBtn:'1',helpBtn:'1'},
      {currentPage:'in_p3',knowledgeBtn:'1',helpBtn:'1'},
      {currentPage:'in_p4',knowledgeBtn:'1',helpBtn:'1'},
      {currentPage:'in_p5',knowledgeBtn:'1',helpBtn:'1'},
      {currentPage:'in_p6',knowledgeBtn:'1',helpBtn:'1'},
      {currentPage:'in_p7',knowledgeBtn:'1',helpBtn:'1'},
      {currentPage:'in_p8',knowledgeBtn:'1',helpBtn:'1'},
      {currentPage:'in_p9',knowledgeBtn:'1',helpBtn:'1'},
      {currentPage:'in_p10',knowledgeBtn:'1',helpBtn:'1'},
    ]
  }

  export function creditRuleEntityList() {
    return [
      {regInfo:"姓名",credit: 10,correctShow:"填写正确",errorShow:"填写错误",knowledgePoint:"填写内容为法人代表姓名" },
      {regInfo:"电话号码",credit: 8,"correctShow":"填写正确",errorShow:"填写错误",knowledgePoint:"选择“输入有效印度电话号码”" },
      {regInfo:"邮箱",credit: 5,"correctShow":"填写正确",errorShow:"填写错误",knowledgePoint:"填写内容为注册邮箱收到的注册链接的邮箱，请确保此邮箱未在亚马逊使用过" },
      {regInfo:"公司法定名称",credit: 8,"correctShow":"填写正确",errorShow:"填写错误",knowledgePoint:"填写公司法定名称" },
      {regInfo:"店铺名称",credit: 3,"correctShow":"填写正确",errorShow:"填写错误",knowledgePoint:"此处请自行设置店铺名称，非公司名称" },
      {regInfo:"公司所在地邮编",credit: 5,"correctShow":"填写正确",errorShow:"填写错误",knowledgePoint:"填写内容为营业执照地址邮编" },
      {regInfo:"公司地址栏1",credit: 5,"correctShow":"填写正确",errorShow:"填写错误",knowledgePoint:"填写内容为营业执照详细地址，地址栏1填不下时填到地址栏2" },
      {regInfo:"公司地址栏2",credit: 5,"correctShow":"填写正确",errorShow:"填写错误",knowledgePoint:"填写内容为营业执照详细地址，地址栏1填不下时填到地址栏2" },
      {regInfo:"公司所在城市",credit: 3,"correctShow":"填写正确",errorShow:"填写错误",knowledgePoint:"填写内容为营业执照地址城市" },
      {regInfo:"公司所在区域/州",credit: 3,"correctShow":"填写正确",errorShow:"填写错误",knowledgePoint:"填写内容为营业执照地址区域/州" },
      {regInfo:"产品运送方式",credit: 3,"correctShow":"填写正确",errorShow:"填写错误",knowledgePoint:"请务必选择亚马逊FBA运送模式，其他模式将无法下发链接" },
      {regInfo:"两步验证手机号",credit: 8,"correctShow":"填写正确",errorShow:"填写错误",knowledgePoint:"输入有效印度备用电话号码" },
      {regInfo:"GST号码",credit: 5,"correctShow":"填写正确",errorShow:"填写错误",knowledgePoint:"填写所有使用单一电子商务平台的卖家都需要商品和服务纳税人识别码（GSTIN）" },
      {regInfo:"PAN号码",credit: 5,"correctShow":"填写正确",errorShow:"填写错误",knowledgePoint:"填写PAN号码，（PAN）是由所得税部门发行的十位字母数字" },
      {regInfo:"运费明细",credit: 3,"correctShow":"选择正确",errorShow:"选择错误",knowledgePoint:"在此设置好您要向客户收取的运费" },
      {regInfo:"银行账户明细-持有人姓名",credit: 3,"correctShow":"填写正确",errorShow:"填写错误",knowledgePoint:"填写印度开通的银行账户的持有人姓名" },
      {regInfo:"银行账户明细-账户类型",credit: 3,"correctShow":"填写正确",errorShow:"填写错误",knowledgePoint:"选择印度开通的银行账户的账户类型" },
      {regInfo:"银行账户明细-账号",credit: 3,"correctShow":"填写正确",errorShow:"填写错误",knowledgePoint:"填写印度开通的银行账户的账号" },
      {regInfo:"银行账户明细-重新输入账号",credit: 3,"correctShow":"填写正确",errorShow:"填写错误",knowledgePoint:"再次填写印度开通的银行账户的账号" },
      {regInfo:"银行账户明细-IFSC代码",credit: 3,"correctShow":"填写正确",errorShow:"填写错误",knowledgePoint:"填写印度开通的银行账户的IFSC代码" },
      {regInfo:"默认产品税码",credit: 3,"correctShow":"选择正确",errorShow:"选择错误",knowledgePoint:"选择产品税码" },
      {regInfo:"签名",credit: 3,"correctShow":"填写正确",errorShow:"填写错误",knowledgePoint:"在屏幕上绘制本人姓名（即法人姓名）" }
    ]    
  }
  
